<template>
    <div class="A4">
        <div class="row">
            <div class="col-sm-12">
                <div class="print-header">
                    <h4 class="text-center font-m">{{$t('purchase_operation')}}</h4>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <table class="table table-bordered table-sm table-striped no-bor">
                    <thead>
                        <tr>
                            <th style="width: 50px;" class="text-center">{{$t('no')}}</th>
                            <th>{{$t('code')}}</th>
                            <th>{{$t('date')}}</th>
                            <th>{{$t('vendor')}}</th>
                            <th class="text-right">{{$t('grand_total')}}</th>
                            <th class="text-right">{{$t('discount')}}</th>
                            <th class="text-right">{{$t('total_amount')}}</th>
                            <th class="text-right">{{$t('balance')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ret.Num}}</td>
                            <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                            <td>{{ret.VendorName}}</td>
                            <td class="text-right">{{$money(ret.GrandTotal)}}</td>
                            <td class="text-right">{{$money(ret.Discount)}}</td>
                            <td class="text-right">{{$money(ret.PaidAmount)}}</td>
                            <td class="text-right">{{$money(ret.Balance)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="4" class="text-right">{{$t('total')}}</th>
                            <th class="text-right">{{$money(summary.GrandTotal)}}</th>
                            <th class="text-right">{{$money(summary.Discount)}}</th>
                            <th class="text-right">{{$money(summary.TotalAmount)}}</th>
                            <th class="text-right">{{$money(summary.Balance)}}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function () {
            return {
                query: {
                    Year: new Date().getFullYear(),
                    Month: new Date().getMonth() + 1,
                    CompanyId: this.$store.state.company.Id
                },
                records: [],
                summary: {
                    GrandTotal: 0,
                    Discount: 0,
                    TotalAmount: 0,
                    TotalCost: 0,
                    GrossProfit: 0,
                    Balance: 0
                }
            }
        },
        created: function () {
            let linkQuery = this.$route.query;
            if (linkQuery.year != undefined && linkQuery.year != null && linkQuery.year != '') {
                this.query.Year = linkQuery.year;
            }
            if (linkQuery.month != undefined && linkQuery.month != null && linkQuery.month != '') {
                this.query.Month = linkQuery.month;
            }
            this.toList();
        },
        methods: {
            toList() {
                var loading = this.$loading.show();
                this.$api().post('report/purchase/operations', this.query).then((res) => {
                    if (this.$isValid(res)) {
                        this.records = res.data.Json.Headers;
                        this.calculate();
                    }
                }).finally(function () { loading.hide(); });
            },
            calculate() {
                let grand_total = 0;
                let discount = 0;
                let totalAmount = 0;
                let balance = 0;
                this.records.map(el => {
                    grand_total += el.GrandTotal;
                    discount += el.Discount;
                    totalAmount += el.PaidAmount;
                    balance += el.Balance;
                });
                this.summary.GrandTotal = grand_total;
                this.summary.Discount = discount;
                this.summary.TotalAmount = totalAmount;
                this.summary.Balance = balance;
            }
        }
    }
</script>